import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect — page killed in the Local-Dominance pivot.
// This URL now points to the Colorado coverage page; topical authority
// is being concentrated on Colorado Springs + El Paso County + Tier-1 cities
// (Monument, Castle Rock, Parker) where we actually rank and convert.
export const Route = createFileRoute("/lakewood-geo-ai")({
  beforeLoad: () => {
    throw redirect({ to: "/colorado-coverage", statusCode: 301 });
  },
  component: () => null,
});
